import React from "react";
import PropTypes from "prop-types";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import {
  FormWrapper,
  Form,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";
import useEmpresa from "../../../../hooks/useEmpresa";
import { cleanNumber } from "../../../../utils/NumberUtil";

const ConfiguracionStandVirtualBusquedaForm = ({
  tipoPss,
  codigoPss,
  onStateChange,
  onSearch,
  isLoading,
  handleKeyPress
}) => {
  const empresa = useEmpresa();

  const onForm = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <Section>
      <FormWrapper borderColor={Colors.transparent}>
        <Form justifyContent={"space-between"} onSubmit={onForm}>
          <FormGroup width={"48%"}>
            <CustomSelect
              type={"text"}
              font={empresa?.LETRA_PRINCIPAL}
              label={"Tipo PSS"}
              isLabelWithContainer={true}
              labelWidth={"100%"}
              width={"100%"}
              value={tipoPss}
              options={[
                { value: "MEDICO", label: "MEDICO" },
                { value: "NO_MEDICO", label: "NO MEDICO" }
              ]}
              onChange={onStateChange("tipoPss")}
            />
          </FormGroup>

          <FormGroup width={"48%"}>
            <CustomInput
              font={empresa?.LETRA_PRINCIPAL}
              type={"text"}
              placeholder={"Código PSS"}
              label={"Código PSS"}
              isLabelWithContainer={true}
              width={"95%"}
              labelWidth={"100%"}
              value={codigoPss}
              onChange={onStateChange("codigoPss", cleanNumber)}
              handleKeyPress={handleKeyPress}
            />
          </FormGroup>

          <FormGroup>
            <CustomButton
              label={"Buscar"}
              width={"200px"}
              isLoading={isLoading}
              type={"submit"}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </Section>
  );
};

ConfiguracionStandVirtualBusquedaForm.propTypes = {
  tipoPss: PropTypes.string.isRequired, // Tipo PSS seleccionado
  codigoPss: PropTypes.string, // Código PSS ingresado
  onStateChange: PropTypes.func.isRequired, // Función para manejar cambios de estado
  onSearch: PropTypes.func.isRequired, // Función para ejecutar la búsqueda
  isLoading: PropTypes.bool, // Indica si el botón de búsqueda está en estado de carga
  handleKeyPress: PropTypes.func // Función para manejar eventos de teclado
};

export default ConfiguracionStandVirtualBusquedaForm;
